import {useOrdersStore} from './orders'
import {useServicesStore} from './services'
import {usePersonsStore} from './persons'
import {useWorkingTimeStore} from './workingTime'
import {useInfosStore} from './infos'
import {useSettingsStore} from './settings'
export function resetSessionData(): void {
  for (const store of [useOrdersStore(),useServicesStore(),usePersonsStore(),useWorkingTimeStore(),useInfosStore(),useSettingsStore()]) store.$reset()
}
